import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    ButtonToolbar,
    Popover
} from "react-bootstrap";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Card} from "components/Card/Card.jsx";
import {roleActions} from '../../../redux/actions/role-actions';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import {FormInputs} from "components/FormInputs/FormInputs.jsx";
import {hasPermission} from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import {helperFunctions as HF} from '../../../helper/helperFunctions';
import {stateActions} from '../../../redux/actions/state-actions';
import {Link} from 'react-router-dom';
import {brandActions} from '../../../redux/actions/brand-actions';

var Modal = require('react-bootstrap-modal');

const moment = window.moment;

class BrandsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addModalState: false,
            editModalState: false,
            sorted: '',
            filtered: '',
            pageSize: 10,
            brands: [
                {
                    brandName: 'Lucky',
                    shortCode: '1AA',
                    openOrders: 'New: In progess',
                    primaryContact: 'Sherri mae 447, Sunset boulevard',
                    accountingContact: 'Sherri mae 447, Sunset boulevard',
                    created_date: 'Aug 29 2019',
                    value: 1,
                },
            ]
        };

        this.callEditState = this.callEditState.bind(this);
        this.deleteBrand = this.deleteBrand.bind(this);
        this.deleteConfirmBrand = this.deleteConfirmBrand.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);
        this.handleStateSubmit = this.handleStateSubmit.bind(this);

        this.brandsPaginationData = this.brandsPaginationData.bind(this);
    };

    handleStateSubmit(stateData, formType) {
        if (formType === 'add')
            this.props.storeStateCall(stateData);
        else if (formType === 'edit')
            this.props.editStateCall(stateData, this.props.editState.value);
    }

    filterSearchHandle(e) {
        this.setState({
            'filtered': e.target.value
        }, () => {
            this.refReactTable.fireFetchData()
        });
    }

    callEditState(id) {
        this.setState({
            editModalState: true
        })
        this.props.getStateCall(id);
    }

    deleteBrand(brandId) {
        this.props.deleteBrandCall(brandId).then(res => {
            this.props.getBrandsListCall(this.props.current_page, '', '', this.state.pageSize);
        });
    }

    //
    deleteConfirmBrand(brandId) {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="Brand" description="Are you sure to delete this brand?"
                                           onClosePro={onClose} deleteType={() => this.deleteBrand(brandId)}/>
                )
            }
        })
    }

    brandsPaginationData(page, filter, sort, pageSize) {
        this.setState({pageSize: pageSize}, function () {
            this.props.getBrandsListCall(page, filter, sort, pageSize);
        });
    }

    wait = ms => new Promise(resolve => setTimeout(resolve, ms));

    dclick = async (e) => {
        let arr = Array(2).fill(2);
        let count = 1;

        for (let i = 0; i < arr.length; i++) {
            await this.wait(5000);

            count++;
            let rse = await this.props.getBrandsListCall(1, '', '', 1);
            if (count%10 === 1) {
            }
            // if (count >= 25) {
            //     setTimeout(async () => {
            //         count++;
            //         await this.props.getBrandsListCall(1, '', '', 1);
            //     }, 5000)
            // } else {
            //     let rse = await this.props.getBrandsListCall(1, '', '', 1);
            //     count++;
            // }

        }
    }

    render() {
        const {pages, loading, countries} = this.props;
        const {states, editState, brandsPaginatedData} = this.props;
        const columns = [
            {
                Header: "Brands Listing",
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: "Brand Name",
                        accessor: "title",
                        className: "action-center",
                    },
                    {
                        Header: "Short Code",
                        accessor: "short_code",
                        className: "action-center"
                    },
                    {
                        Header: "Open Orders",
                        accessor: "orders_count",
                        className: "action-center"
                    },
                    {
                        Header: "Primary Contact",
                        accessor: "primary_contacts",
                        className: "action-center"
                    },
                    {
                        Header: "Admin Contact",
                        accessor: "administrative_email",
                        className: "action-center"
                    },
                    {
                        Header: "Created Date",
                        accessor: "created_at",
                        className: "action-center",
                        Cell: ({value, original}) => (
                            <div>
                                {
                                    moment(value).format('MM/DD/YYYY')
                                }
                            </div>

                        )
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        Cell: ({value, original}) => (
                            <div>
                                <ButtonToolbar>
                                    <OverlayTrigger trigger="focus" placement="left" overlay={
                                        <Popover id="brandActions">
                                            <table className="table text-left actions_table" width="100%">
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('brands-list') &&
                                                            <Link to={{
                                                                pathname: `/Admin/brand/${value}/edit`,
                                                                state: {
                                                                    brandData: original,
                                                                    type: 'edit',
                                                                }
                                                            }} className="btn_link "><i className="fa fa-pencil"/> Edit</Link>
                                                        }
                                                        {
                                                            !hasPermission('brands-list') &&
                                                            <button type='button' className="btn_link button_disabled">
                                                                <i className="fa fa-pencil danger"/> Edit</button>
                                                        }
                                                    </td>

                                                    <td>
                                                        {
                                                            hasPermission('permission-delete') &&
                                                            <button onClick={() => this.deleteConfirmBrand(value)}
                                                                    className="btn_link text-danger"><i
                                                                className="fa fa-trash text-danger "/> Delete</button>

                                                        }
                                                        {
                                                            !hasPermission('permission-delete') &&
                                                            <button type='button' className="btn_link button_disabled">
                                                                <i className="fa fa-trash text-danger"/> Delete</button>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand/' + value + '/users'}
                                                                  className=""><i className="fa fa-users"/> Users</Link>
                                                        }
                                                        {
                                                            !hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand/' + value + '/users'}
                                                                  className=""><i className="fa fa-users"/> Users</Link>
                                                        }
                                                    </td>

                                                    <td>
                                                        {
                                                            hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand/' + value + '/contacts'}
                                                                  className=""><i
                                                                className="fa fa-users"/> Contacts</Link>
                                                        }
                                                        {
                                                            !hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand/' + value + '/contacts'}
                                                                  className=""><i
                                                                className="fa fa-users"/> Contacts</Link>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand/' + value + '/tag-layouts'}
                                                                  className=""><i className="fa fa-tags"/> Tag
                                                                Layouts</Link>
                                                        }
                                                        {
                                                            !hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand/' + value + '/tag-layouts'}
                                                                  className=""><i className="fa fa-tags"/> Tag
                                                                Layouts</Link>

                                                        }
                                                    </td>

                                                    <td>
                                                        {
                                                            hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand-data/' + value} className=""><i
                                                                className="fa fa-file"/> POs / Styles</Link>
                                                        }
                                                        {
                                                            !hasPermission('brand-user-list') &&
                                                            <Link to={'/Admin/brand-data/' + value} className=""><i
                                                                className="fa fa-file"/> POs / Styles</Link>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('brand-user-list') &&
                                                            <Link to={`/Admin/brand/${value}/lookup-listing`}
                                                                  className=""><i className="fa fa-file"/> Lookup
                                                                Definitions</Link>
                                                        }
                                                        {
                                                            !hasPermission('brand-user-list') &&
                                                            <Link to={`/Admin/brand/${value}/lookup-listing`}
                                                                  className=""><i className="fa fa-file"/> Lookup
                                                                Definitions</Link>
                                                        }
                                                    </td>

                                                    <td>
                                                        {
                                                            hasPermission('view-product-data-definitions') &&
                                                            <Link to={'/Admin/brand/' + value + '/data-definitions'}
                                                                  className="orderDetailsAction"><i
                                                                className="fa fa-file"/> Data Definitions</Link>
                                                        }
                                                        {
                                                            !hasPermission('view-product-data-definitions') &&
                                                            <button className="orderDetailsAction button_disabled"><i
                                                                className="fa fa-file"/> Data Definitions</button>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Link to={'/Admin/brand/' + value + '/addresses'}
                                                              className=""><i className="fa fa-file"/> Addresses</Link>
                                                    </td>
                                                    <td>
                                                        {
                                                            hasPermission('agency-resource-list') &&
                                                            <Link to={'/Admin/' + value + '/data-definitions'}
                                                                  className=""><i className="fa fa-file"/> Orders</Link>
                                                        }
                                                        {
                                                            !hasPermission('agency-resource-list') &&
                                                            <Link to={'/Admin/' + value + '/data-definitions'}
                                                                  className=""><i className="fa fa-file"/> Orders</Link>
                                                        }
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                        </Popover>
                                    }>
                                        <span>
                                            <button type='button' className="action-button-size"><i
                                                className="fa fa-bars"/></button>
                                        </span>
                                    </OverlayTrigger>
                                </ButtonToolbar>
                            </div>
                        ),
                        className: "action-center",
                        sortable: false
                    }
                ]
            }
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3 style={{textAlign: 'center', fontWeight: "500"}}>Brands
                                                        List</h3>
                                                </Col>
                                                <Col md={12}>
                                                    <div className="flexElem flexResponsive mt-xlg" style={{
                                                        "alignItems": "flex-start",
                                                        "justifyContent": "space-between"
                                                    }}>
                                                        <div className="block">
                                                            {
                                                                hasPermission('list-create') ?
                                                                    <Link to="/Admin/brand-wizard"
                                                                          className={['customBtn btnBlue']}
                                                                          name="Add Brand"
                                                                    >Add Brand</Link>
                                                                    :
                                                                    <button
                                                                        className={['backButton pt-sm no_radius pb-sm primary mt-none btn-block btn-info btn']}
                                                                        name="Add Brand"
                                                                        disabled
                                                                    >
                                                                        Add Brand
                                                                    </button>
                                                            }

                                                        </div>

                                                        <div className="custom-search-input">
                                                            <FormInputs
                                                                ncols={["col-md-12"]}
                                                                onChange={this.filterSearchHandle}
                                                                proprieties={[
                                                                    {
                                                                        type: "text",
                                                                        bsClass: "form-control",
                                                                        placeholder: "Search Brands",
                                                                        onChange: this.filterSearchHandle,
                                                                        name: "filter"
                                                                    }
                                                                ]}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={12} className="mt-xlg">
                                                    <ReactTable
                                                        noDataText='No brands found'
                                                        data={brandsPaginatedData}
                                                        pages={pages}
                                                        loading={loading}
                                                        columns={columns}
                                                        defaultPageSize={10}
                                                        className="-striped listing responsive"
                                                        pageData={this.brandsPaginationData}
                                                        ref={(refReactTable) => {
                                                            this.refReactTable = refReactTable;
                                                        }}
                                                        manual
                                                        onFetchData={(state, instance) => {
                                                            var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                            state.pageData(state.page + 1, this.state.filtered, sort, state.pageSize);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>

                                        {/*Add State Modal Start*/}
                                        {states !== null &&
                                        <Modal show={this.state.addModalState}
                                               onHide={HF.closeModal.bind(this, "addModalState")}
                                               aria-labelledby="ModalHeader">
                                            <Modal.Header closeButton>
                                                <Modal.Title id='ModalHeader' className="headerTitle">Add
                                                    State</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="row">
                                                    <div className="col-md-12">

                                                    </div>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                        }

                                        {/*Add STATE Modal End*/}

                                        {/*Edit STAte Modal start*/}
                                        {editState && countries !== null &&
                                        <Modal show={this.state.editModalState}
                                               onHide={HF.closeModal.bind(this, "editModalState")}
                                               aria-labelledby="ModalHeader">
                                            <Modal.Header closeButton>
                                                <Modal.Title id='ModalHeader' className="headerTitle">Edit
                                                    State</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="row">
                                                    <div className="col-md-12">

                                                    </div>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                        }
                                        {/*Edit State Modal End*/}
                                    </div>
                                }/>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => {
    return ({
        getAllRolesCall: () => {
            dispatch(roleActions.getUserRoles())
        },
        getStatesCall: (page, filter, sort, pageSize) => {
            dispatch(stateActions.getStatesPagination(page, filter, sort, pageSize))
        },
        storeStateCall: (stateData) => {
            dispatch(stateActions.storeState(stateData))
        },
        editStateCall: (stateData, id) => {
            dispatch(stateActions.editState(stateData, id))
        },
        deleteBrandCall: (id) => {
            return dispatch(brandActions.deleteBrand(id))
        },
        getStateCall: (id) => {
            dispatch(stateActions.getState(id))
        },

        getBrandsListCall: (page, filter, sort, pageSize) => {
            return dispatch(brandActions.getBrandsList(page, filter, sort, pageSize))
        },
    });
};

function mapStateToProps(state) {
    const {loading, pages, current_page, brandsPaginatedData} = state.brandReducer;
    return {
        loading, pages, current_page, brandsPaginatedData
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BrandsList);



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandsList.jsx